import { constants, typographyStyles } from "@newsela/angelou";

const { ui } = constants.colors;
const { fontSize } = typographyStyles;

const lightBlue = ui.core[25];
const grey = ui.neutral[500];

export const iconCss = {
  height: "8rem",
  margin: "29px 0 30px 16px",
  width: "12rem",
};

export const containerCss = {
  backgroundColor: lightBlue,
  borderRadius: "8px",
  display: "flex",
  width: "100%",

  "div:nth-type(2)": {
    display: "flex",
    flexDirection: "column",
  },
};

export const headingCss = {
  ...fontSize.heading4,
  margin: "40px 0 16px 33px",
};

export const messageCss = {
  ...fontSize.heading6,
  color: grey,
  margin: "0 54px 0 33px",
};
